import { useEffect, useState } from "react";

/**
 * A value as it stood `delay` ms after it last changed, compared by its
 * JSON so a new object with the same contents is no change. For a live
 * count that should not ask on every key.
 */
export function useDebounced<Value>(value: Value, delay = 350): Value {
    const text = JSON.stringify(value);
    const [settled, setSettled] = useState(text);
    useEffect(() => {
        const timer = window.setTimeout(() => setSettled(text), delay);
        return () => window.clearTimeout(timer);
    }, [text, delay]);
    return JSON.parse(settled) as Value;
}
